<template>
  <div>
    <div class="product-container">
      <Bread
        first-name="产品中心"
        metertype="智慧水务"
        meter-name="卡表"
      ></Bread>
      <div class="top-title">
        <h1>西安星年物联网</h1>
      </div>
      <div class="info">
        <el-row :gutter="16">
          <el-col :span="16">
            <h1>卡表（模块）</h1>
            <div class="introduce">
              <div class="title">产品介绍</div>
              <div class="intro-text">
                <p>
                  智能IC卡水表是一种利用现代微电子技术、现代传感技术、智能IC卡技术对用水量进行计量并进行用水数据传递及结算交易的新型水表。它除了可对用水量进行记录和电子显示外，还可以按照约定对用水量自动进行控制，并且自动完成阶梯水价的水费计算，同时可以进行用水数据存储的功能。由于其数据传递和交易结算通过IC卡进行，因而可以实现由工作人员上门抄表收费到用户自己去营业所交费的转变。
                </p>
              </div>
            </div>
            <div class="trait">
              <div class="title">功能特点</div>
              <div class="intro-text">
                <p>
                  1、本IC卡智能水表一户一表，不可复制，预收费用，无需抄表，是水管部门实现科学智能化的技术手段。
                </p>
                <p>
                  2、本IC卡水表用超大规模专用微处理集成电路、高可靠性设计和专业制造手段，具有防湿、防潮、抗干
                  扰、抗攻击等优越特点。
                </p>
                <p>
                  3、双信号源、中断脉冲方式采集读数，确保无干扰发讯有效信号，准确无误。
                </p>
                <p>
                  4、防范措施完善：双采集信号、电源电池、输入卡座及水表本体等遇到非法强磁干扰、强电流
                  冲击、断路、短路、拆卸、拆电等都得到民示和有效保护。
                </p>
                <p>
                  5、用户购水卡采有大容量AT88SC1608逻辑加密卡和多种加密技术，防伪性好，可任意组合或独立分别管理8种表具，是实现银行电子货币、一卡通管理的方式。
                </p>
                <p>
                  6、可随时查看水表的累计总用水量，当前可用水量与购水量以及使用状况等情况。
                </p>
                <p>
                  7、用户购水卡可反复使用，寿命达10万次左右，防磁防水、易于保存，购水卡损坏或遗失，可即时到水管部门报失补卡。
                </p>
                <p>
                  8、液晶显示：5位数字、14种状态中文、4种状态符号、水表各种使用状态、清晰易查询。
                </p>
                <p>
                  9、本IC卡智能水表采有、强劲微功耗电阀门，以及外置电池。用户可自由更换电池，消除了用户对电池使用寿命的担忧。
                </p>
                <p>
                  10、本表控制器终端软件采用国际与国内银行通行公共安全密钥安全共用的规范标准设计制作,密钥安全共用、充值售卡机具共享、IC卡卡片互通互用，可轻松兼容和嫁接原有的水管部门售水管理软件系统使用。
                </p>
              </div>
            </div>
            <div></div>
          </el-col>
          <el-col :span="8">
            <!-- <div class="meter-img">
              <img src="@/svg/watermeter.jpg" />
            </div> -->
            <div class="meter-img">
              <img src="@/svg/ICmeter.png" />
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
export default {}
</script>
<style lang="scss" scope>
.box {
  font-size: 42px;
}
.top-title {
  padding: 100px 0 0 0;
  border-bottom: 4px solid #4e56c5;
  h1 {
    color: #4e56c5;
  }
}
.info {
  h1 {
    text-indent: 1cm;
    color: #3ab0e7;
  }
  .introduce {
    padding: 60px 0 0 0;
    .title {
      text-indent: 1cm;
      font-size: 24px;
      color: #3ab0e7;
    }
    .intro-text {
      padding: 20px 0 0 20px;
      text-indent: 1cm;
      line-height: 30px;
    }
  }
  .trait {
    padding: 60px 0 0 0;
    .title {
      text-indent: 1cm;
      font-size: 24px;
      color: #3ab0e7;
    }
    .intro-text {
      padding: 20px 0 0 20px;
      text-indent: 1cm;
      line-height: 30px;
    }
  }
  background-color: #fff;
  margin: 100px 0 0 0;
  .meter-img {
    img {
      width: 370px;
    }
  }
}
</style>
